import React, { ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';
import { GlassPageBg } from '../../components/glass/GlassPageBg';

/** Fundo glass do app e a coluna de conteúdo da Central (rota com `isGlass`). */
export function FundoCentral({ children }: { children: ReactNode }) {
  return (
    <GlassPageBg>
      <Flex
        direction="column"
        gap="22px"
        maxW="1240px"
        mx="auto"
        px={{ base: '16px', md: '32px' }}
        pt={{ base: '24px', md: '40px' }}
        pb="40px"
      >
        {children}
      </Flex>
    </GlassPageBg>
  );
}
